import React ,{useState} from "react";
import styles from "../../../styles/pages/globalsearch.module.scss";
import Icons from "../../../public/assets/svg";
import { useDispatch, connect } from "react-redux";
import endpoints from "../../../utility/endpoints";
import _get from "lodash/get";
import { useMediaQuery } from 'react-responsive'
import { useRouter } from "next/router";


function index(props) {
 
  const router = useRouter();

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })

  //console.log("props-------------", props);
  const openBotDetailPage = (botID) => {
    // router.push({
    //   pathname: "/botDetails",
    //   query: { botID: botID, searchResults : true },
    // });

    window.open(endpoints.redirectUriLogin+`botDetails?botID=${botID}&searchResults=${true}`)
  };

  const downloadPdf = (pdfLink) => {
    window.open(pdfLink);
  };

  const formatDocumentSize = (sizeInBytes) => {
    const megaBytes = sizeInBytes / 1e6;
    const kiloBytes = sizeInBytes / 1e3;

    if (megaBytes >= 1) {
      return `${megaBytes.toFixed(1)} mb`;
    } else {
      return `${Math.trunc(kiloBytes)} kb`;
    }
  };

  
  function camelize(str) {
    return str.toString()
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  let intialState = {
    cez: false,
    botindex: false,
    framework: false,
    contact_us: false,
    all:true
  }
  let indexes = ['cez', 'botindex', 'framework','contact_us'];
  const [globalIndex, setglobalIndex] = useState(intialState)
  React.useEffect(() => {
    //console.log('global search ', props);
    try {
      if (props.searchResult != null) {
        let indexesFromSearch = Object.keys(props.searchResult);
        //console.log(props.searchResult, "SEARCHH")
        let dummy =globalIndex;
        //console.log('Index from search ---', indexesFromSearch);
      
        for (let i = 0; i < indexes.length; i++) {

          if (indexesFromSearch.includes(indexes[i])) {
            //console.log("index of --", indexes[i]);
            //console.log("global1234", globalIndex);
            
            if (props.searchResult[indexes[i]].length > 0) {
              dummy[indexes[i]] = true;
              
            }
            else {
              dummy[indexes[i]] = false;
            
            }
          }
        }
        let flag = true
        for (let i in dummy) {
          if (i != "all") {
            if (dummy[i] == true)
            flag = false
          }
        }
        dummy.all = flag
        setglobalIndex({ ...dummy });
      }
    } catch (e) {
      console.log(e);
    }
  }, [props])

    React.useEffect(() => {
      //console.log(globalIndex, 'testing');
    }, [globalIndex])


    const contact =  _.get(props,"searchResult.contact_us[0]._source.email")
  return (
    <div className={`${styles.container} container my-4`}>
      <div className={styles.globalContainer}>
        
        {globalIndex.all
          ? (
          <div className={styles.noresults}>
            <img src="/assets/svg/noresult.png" />
            <h3 className={styles.head}>No Results to show</h3>
            <p>Please check spelling or try different keywords.</p>
          </div>
        ) : (
          <>
            <p className={styles.head}>
              {" "}
            Below listed are the results for the keyword(s) you searched.
          </p>

            <p className={styles.text}>
              {" "}
            Keyword: <strong className={styles.data}>{props.keyword}</strong>
            </p>
            {globalIndex.cez ==false? null : (
                <div className={styles.cezSearch}>
                  <p className={styles.cezhead}>Experience Zone</p>
                  {_get(props.searchResult, "cez", []).map((c, i) => (
                    <div className={styles.datacez}>
                      <p className={styles.datahead}
                        onClick={() => {
                      //   router.push({
                      //   pathname: "/cez",
                      //   query: { cezSection: c._source.title ==  "Conversational AI" ? "Conversational AI"  : c._source.title == "Test Classification & Analytics" ? "Test classification & analytics": c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization": "" },
                      // });
                      window.open(`${endpoints.redirectUriLogin}cez?cezSection=${c._source.title ==  "Conversational AI" ? "Conversational AI"  : c._source.title == "Text Classification & Analytics" ? "Text+classification+%26+analytics": c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization": ""}`)
                    
                    
                    
                    }}
                      >{c._source.title}</p>
                      <p
                        className={styles.datadetail}
                        onClick={() => {
                          // router.push({
                          //   pathname: "/cez",
                          //   query: { cezSection: c._source.title ==  "Conversational AI" ? "Conversational AI"  : c._source.title == "Test Classification & Analytics" ? "Test classification & analytics": c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization": "" },
                          // });

                          window.open(`${endpoints.redirectUriLogin}cez?cezSection=${c._source.title ==  "Conversational AI" ? "Conversational AI"  : c._source.title == "Text Classification & Analytics" ? "Text+classification+%26+analytics": c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization": ""}`)
                        }}
                      >
                        View Details
                  </p>
                    </div>
                  ))}
                </div>
              )}

            {globalIndex.botindex==false ? null : (
              <div className={styles.botSearch}>
                <p className={styles.bothead}>Bot Store</p>
                {_get(props.searchResult, "botindex", []).sort((a,b) => a._source.botID<b._source.botID ? 1 : -1).map((b, i) => (
                  <div className={styles.databot}>
                    <div className={styles.cardHead}>
                      <div className={styles.icon}>
                        <Icons
                          onClick={() => openBotDetailPage(b._source.botID)}
                          name={camelize(b._source.leadPlatform)}
                          className={styles.shoppingIcon}
                        />
                      </div>
                      <div className={styles.text}>
                        <p className={styles.code}>{b._source.botID + "        -        " + b._source.processName}</p>
                        {isTabletOrMobile ?
                        <p className={styles.label}  onClick = {()=>{openBotDetailPage(b._source.botID)}}>{b._source.leadPlatform}</p> :
                        <p className={styles.label}>{b._source.leadPlatform}</p> }
                      </div>
                    </div>
                    <p
                      className={styles.datadetail}
                      onClick={() => openBotDetailPage(b._source.botID)}
                    >
                      View Details
                  </p>
                  </div>
                ))}
              </div>
            )}
            {globalIndex.framework ==false ? null : (
              <div className={styles.frameworkSearch}>
                <p className={styles.frameworkhead}>Framework</p>
                <div className={styles.dataframe}>
                  {_get(props.searchResult, "framework", []).map((c, i) => (
                    <div className={styles.pdfCard}>
                      <div className={styles.pdfhead}>
                        <div className={styles.iconWrap}>
                         
                          <Icons name={camelize(c._source.docType)} className={styles.icon} />
                        </div>

                        <div class={styles.pdfTitle}>
                          <p>{c._source.docName}</p>
                          <small>{formatDocumentSize(c._source.docSize)}</small>
                        </div>
                        <div onClick = {() =>{downloadPdf(
                            `${endpoints.fetchBlobUrl}/${c._source.docUrl}`);
                          }}
                          className={styles.mobileDownloadIcon} >
                            <Icons name="downloadBlue"></Icons>
                        </div>
                      </div>
                      <div className={styles.body}>
                        <div className={styles.downloadOverlay}>
                          <div  onClick = {() =>{downloadPdf(
                            `${endpoints.fetchBlobUrl}/${c._source.docUrl}`);
                          }}
                          className={styles.downloadBtn}>
                            <Icons
                              name="downloadWhite"
                              className={styles.download}
                            />
                            <span>Download</span>
                          </div>
                        </div>
                        <div className={styles.objWrapper}>
                        <iframe
                  style={{ width: "100%" }}
                  src={
                    c._source.docType == "xlsx" ||
                    c._source.docType == "doc" ||
                    c._source.docType == "docx"
                      ? `https://docs.google.com/viewerng/viewer?embedded=true&url=${endpoints.fetchBlobUrl}/FrameworkDocuments/${c._source.docUrl}`
                      : c._source.docType == "ppt" ||
                      c._source.docType == "pptx" ||
                      c._source.docType == "msg"
                      ? `https://view.officeapps.live.com/op/embed.aspx?src=${endpoints.fetchBlobUrl}/FrameworkDocuments/${c._source.docUrl}`
                      : `${endpoints.fetchBlobUrl}/FrameworkDocuments/${c._source.docUrl}`
                  }
                  type={`application/${c._source.docType}`}
                  width="220"
                  height="100"
                ></iframe>
                        </div>
                      </div>
                    </div>
                  ))}
                  
                </div>
              </div>
            )}

            {globalIndex.contact_us==false ? null : (
              <div className={styles.ContactSearch}>
                <p className={styles.Contacthead}>Contact</p>
                <div className={styles.datacard}>
                
                  {_get(props.searchResult, "contact_us", []).sort((a, b) => (parseInt(a._id.slice(10)) > parseInt(b._id.slice(10))) ? 1 : -1).map((c, i) => (
                    <div className={styles.contactCard}>
                      <div className={styles.userImageWrapper}>
                        <img
                          src={`${endpoints.drupalIp}${_get(c._source, "image")}`}
                          className={styles.imagesrc}
                        />
                      </div>
                      <div className={styles.infoWrapper}>
                        <p className={styles.name}>{c._source.name}</p>
                        <p className={styles.email}>
                            <a href={`mailto:${contact}`}>{c._source.email}</a>
                        
                        </p>
                        <p className={styles.designation}>
                          {c._source.designation}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <p
                      className={styles.datadetail}
                      onClick={() => window.open(endpoints.redirectUriLogin+`contactUs`)}
                    >
                    <span>View More</span> 
                  </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  searchResult: state.search.searchResult,
  keyword: state.search.keyword,
});

export default connect(mapStateToProps, null)(index);
